// src/app/services/auth.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
    // Initialize with the current authentication state from localStorage
    private isAuthenticatedSubject = new BehaviorSubject<boolean>(
      localStorage.getItem('isLoggedIn') === 'true'
    );
  
    constructor(private router: Router, authService: AuthService) {
        console.log('AuthService initialized, isLoggedIn:', localStorage.getItem('isLoggedIn'));
      }
  
    isAuthenticated(): Observable<boolean> {
      return this.isAuthenticatedSubject.asObservable();
    }
  
    login(username: string, password: string): boolean {
    // Hardcoded credentials
    const VALID_USERNAME = 'DiginuEV';
    const VALID_PASSWORD = 'Diginu@evpilot';
    
    if (username === VALID_USERNAME && password === VALID_PASSWORD) {
        console.log('Login successful, updating state');
        localStorage.setItem('isLoggedIn', 'true');
      this.isAuthenticatedSubject.next(true);
      return true;
    }
    console.log('Login failed');
    return false;
  }
  
  logout(): void {
    console.log('Logging out');
    localStorage.removeItem('isLoggedIn');
    this.isAuthenticatedSubject.next(false);
    this.router.navigate(['/login']);
  }
// Method to check current auth state for debugging
checkAuthState(): void {
    const storedState = localStorage.getItem('isLoggedIn') === 'true';
    const currentState = this.isAuthenticatedSubject.value;
    console.log('Stored auth state:', storedState);
    console.log('Current subject state:', currentState);
    
    // Force update if they're out of sync
    if (storedState !== currentState) {
      console.log('Syncing auth state');
      this.isAuthenticatedSubject.next(storedState);
    }
  }
}